import { render, staticRenderFns } from "./TokenDetection.vue?vue&type=template&id=401b35c1&scoped=true&"
import script from "./TokenDetection.vue?vue&type=script&lang=js&"
export * from "./TokenDetection.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetection.vue?vue&type=style&index=0&id=401b35c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b35c1",
  null
  
)

export default component.exports